import { ShieldCheck, Wrench, Ticket, LifeBuoy, Snowflake, BadgeCheck } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "Havarijní pojištění i povinné ručení" },
  { icon: Wrench, label: "Servis a údržba" },
  { icon: Ticket, label: "Dálniční známka" },
  { icon: LifeBuoy, label: "Silniční asistence 24/7" },
  { icon: Snowflake, label: "Přezutí pneumatik" },
  { icon: BadgeCheck, label: "Žádné skryté poplatky" },
];

// „Vše v ceně" pás pod hero – okamžitě ukazuje, že měsíční cena je all-inclusive.
const ValueStrip = () => {
  return (
    <section className="bg-[#0a0a0a] border-y border-white/5 py-6 sm:py-8 px-4 sm:px-6" data-testid="value-strip">
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-xs uppercase tracking-[0.2em] text-orange-400 font-semibold mb-5">Vše v jedné měsíční ceně – bez skrytých poplatků</p>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
          {ITEMS.map((it) => (
            <div key={it.label} className="flex items-center gap-2.5 text-zinc-300 text-sm" data-testid="value-strip-item">
              <it.icon className="w-5 h-5 text-orange-400 shrink-0" />
              <span>{it.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueStrip;
